<template>
  <div :class="['main', isWechat ? 'back-img2' : 'back-img1']"
    :style="{ paddingTop: isWechat ? '0px' : `${statusBarH + 44}px` }">
    <div class="header" :style="{ paddingTop: `${statusBarH + 13}px` }" v-if="!isWechat">
      <img class="left-icon" src="../../assets/img/insurance/left.png" @click="goBack">
    </div>

    <div class="desc">
      <img class="img1" src="../../assets/img/insurance/choice.png">
      <img class="img2" src="../../assets/img/insurance/phone.png">
    </div>

    <div class="content" v-for="item in list" :key="item.projectType">
      <div class="main-title">{{ item.projectName }}</div>
      <div class="info">
        <div class="card" v-for="(item2, index) in item.childProjectList" :key="index"
          @click="handleDetail(item.projectType, item2.title, item2.media)">
          <img class="card-img" :src="titleImg[item2.title] || titleImg1">
          <div class="card-title">{{ item2.title }}</div>
          <div class="card-address">{{ item2.secondTitle }}</div>
          <div class="card-right">
            <img class="card-icon" src="../../assets/img/insurance/right.png">
          </div>
        </div>
      </div>
    </div>


    <van-dialog v-model="show" title="温馨提示" showCancelButton confirmButtonText="同意并前往" @confirm="confirm"
      @cancel="cancel">
      <div class="txt-content">
        <p>保险服务由中国人民财产保险股份有限公司、中国人寿财产保险股份有限公司、中国太平洋财产保险股份有限公司提供，相关保单服务将由慧择保险经纪有限公司提供。</p>
        <p>为了维护您合法权益，您在前往保险机构网站使用本服务前需要充分了解第三方个人信息收集使用规则。为了给您提供更好的服务，需要您同意第三方平台将您的保单信息共享给万达智慧商业使用。</p>
      </div>
    </van-dialog>

  </div>
</template>
<script>
import { Toast } from 'vant'
import { merchantIdentity } from '@/api/insurance.js'
import titleImg1 from '@/assets/img/insurance/type1.png'
import titleImg2 from '@/assets/img/insurance/type2.png'
import titleImg3 from '@/assets/img/insurance/type3.png'
import { LinkPage } from '@/views/Insure-business/hooks.js'
const isWechat = () => {
  return (
    String(navigator.userAgent.toLowerCase().match(/MicroMessenger/i)) ===
    'micromessenger'
  );
};
const titleImg = {
  '服务商': titleImg1,
  '商户': titleImg2,
  '施工方': titleImg3,
}
export default {
  data() {
    return {
      isWechat: isWechat(),
      statusBarH: 0,
      backImg1: require('@/assets/img/insurance/back-img1.png'),
      backImg2: require('@/assets/img/insurance/back-img2.png'),
      titleImg,
      titleImg1,
      titleImg2,
      titleImg3,
      list: [],
      show: false,
      projectType: null,
      pageType: '',
      media: ''

    }
  },
  methods: {
    confirm() {
      this.$router.push({
        path: '/insure_changeStore',
        query: {
          projectType: this.projectType,
          media: this.media
        }
      })
    },
    cancel() { },
    goBack() {

      this.$bsUtils.nativeApi.goBack({ finish: '1' });
    },
    getInsuranceList() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      setTimeout(() => {
        merchantIdentity().then(res => {
          this.list = res
          Toast.clear();
        })
      }, 500)

    },
    handleDetail(projectType, title, media) {
      console.log(projectType, title, media);
      this.media = media
      this.show = true
      this.projectType = projectType
      let pageType = {
        '商户': 'insure_operating',
        '施工方': 'insure_building',
        '服务商': 'insure_service',
      }
      // this.pageType = pageType[title]
      this.$store.commit('base/setPageType', pageType[title] || '');
      // // this.show = true
      // let base_url = process.env.VUE_APP_ENV === 'production' ? 'https://api.xiebao18.com/dispatch/cps/index' : 'https://testapi.xiebao18.com/dispatch/cps/index'

      // let query = {
      //   project: projectType
      // }
      // let url = LinkPage('/index', query)
      // console.log(url);
      // window.location.replace(url)
    }
  },
  mounted() {

    if (!isWechat()) {
      this.$bsUtils.nativeApi.getDeviceInfo().then(res => {
        this.statusBarH = Number(res.statusBarH)
      })
    }

    this.getInsuranceList()

  }

}
</script>

<style lang="less" scoped>
.back-img1 {
  background-image: url('../../assets/img/insurance/back-img1.png');

}

.back-img2 {
  background-image: url('../../assets/img/insurance/back-img2.png');
}

.main {
  text-align: left;
  line-height: 1;
  background-color: #F6F7FB;
  background-repeat: no-repeat;
  background-size: 100% auto;
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  position: relative;

  .header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    padding: 12px;

    .left-icon {
      width: 22px;
      height: 22px;
    }
  }

  .desc {
    padding: 28px 0 28px 20px;

    .img1 {
      width: 170px;
      height: 25px;
    }

    .img2 {
      width: 142px;
      height: 24px;
    }
  }

  .content {
    padding-left: 20px;
    margin-top: 10px;
  }


  .main-title {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #111111;
    margin-top: 16px;
  }

  .info {
    display: flex;
    flex-wrap: wrap;

    .card {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-right: 13px;
      flex-shrink: 0;
      margin-top: 13px;



      width: 104px;
      // height: 135px;
      background: #FFFFFF;
      border-radius: 8px;
      padding: 16px 0 12px 0;

      .card-img {
        width: 40px;
        height: 40px;
      }

      .card-title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #111111;
        margin-top: 10px;
      }

      .card-address {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        margin-top: 8px;
      }

      .card-right {
        // width: 21px;
        // height: 14px;
        background: #F6F7FB;
        border-radius: 7px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 2px 6px;
        margin-top: 8px;

        .card-icon {
          width: 10px;
          height: 10px;
        }
      }
    }
  }

}

.txt-content {
  padding: 0 20px;
  text-indent: 2em;
  line-height: 20px;
  font-size: 14px;
}
</style>